import React, { useState } from 'react'
import ReactVisibilitySensor from 'react-visibility-sensor'
import styles from './KeyMembers.module.scss'
import './KeyMembers.scss'
import 김민정 from 'static/images/key-members/김민정.png'
import 김민정_gray from 'static/images/key-members/김민정_gray.png'
import 김진성 from 'static/images/key-members/김진성.png'
import 김진성_gray from 'static/images/key-members/김진성_gray.png'
import 이소연 from 'static/images/key-members/이소연.png'
import 이소연_gray from 'static/images/key-members/이소연_gray.png'
import 박서희 from 'static/images/key-members/박서희.png'
import 박서희_gray from 'static/images/key-members/박서희_gray.png'
import 최윤석 from 'static/images/key-members/최윤석.png'
import 최윤석_gray from 'static/images/key-members/최윤석_gray.png'
import 강동민 from 'static/images/key-members/강동민.png'
import 강동민_gray from 'static/images/key-members/강동민_gray.png'
import 권다현 from 'static/images/key-members/권다현.png'
import 권다현_gray from 'static/images/key-members/권다현_gray.png'
import 조성학 from 'static/images/key-members/조성학.png'
import 조성학_gray from 'static/images/key-members/조성학_gray.png'
import 김현지 from 'static/images/key-members/김현지.png'
import 김현지_gray from 'static/images/key-members/김현지_gray.png'
import 김슬기 from 'static/images/key-members/김슬기.png'
import 김슬기_gray from 'static/images/key-members/김슬기_gray.png'

import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react'
import { Scrollbar, Pagination, Navigation } from 'swiper'

const Member = ({
  imgSrc,
  imgSrcGray,
  name,
  title,
  englishName,
  discription,
}) => {
  const swiper = useSwiper()
  const swiperSlide = useSwiperSlide()

  console.log(swiperSlide.isActive)
  return (
    <div className={styles['member']}>
      <img
        src={swiperSlide.isActive ? imgSrc : imgSrcGray}
        style={{
          width: swiperSlide.isActive ? '366px' : '210px',
          marginTop: swiperSlide.isActive ? '0' : '110px',
          opacity: swiperSlide.isActive ? '1' : '0.5',
        }}
      />
      {swiperSlide.isActive ? (
        <section className={styles['memeber-introduction']}>
          <div className={styles['memeber-introduction-contents']}>
            <div className={styles['name-area']}>
              <span className={styles['member-name']}>{name}</span>
              <span className={styles['member-title']}>{title}</span>
            </div>
            <div className={styles['english-name']}>{englishName}</div>
            <div
              className={styles['member-discription']}
              dangerouslySetInnerHTML={{ __html: discription }}
            ></div>
          </div>
        </section>
      ) : null}
    </div>
  )
}
const KeyMembers = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const isVisible = true
  return (
    <section className={`container key-members ${styles['key-members']}`}>
      <ReactVisibilitySensor
        onChange={(isVisible) => isVisible && setIsLoaded(true)}
      >
        {({ isVisible }) => (
          <article>
            <h1 className={styles['top']}>
              <div
                className={`${styles['top-content']} ${isVisible || isLoaded ? styles['rise-up'] : ''
                  }`}
              >
                Key Members
              </div>
            </h1>
            <section
              className={`${styles['content']} ${isVisible || isLoaded ? styles['fadein'] : ''
                }`}
            >
              <section className={styles['discription']}>
                플랜이슈에는 무엇이든 만들어내는 해결사 같은 멤버들이
                가득합니다.
              </section>
              <section className={styles['discription']}>
                프로젝트 성공을 위해 열심히 달려가는 보석같은 리더들을
                소개합니다.
              </section>
              <section
                className={`${styles['members']} ${isVisible || isLoaded ? styles['fadein'] : ''
                  }`}
              >
                <Swiper
                  centeredSlides={true}
                  slidesPerView={1}
                  spaceBetween={30}
                  breakpoints={{
                    925: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                    1588: {
                      slidesPerView: 5,
                      spaceBetween: 30,
                    },
                  }}
                  navigation={true}
                  loop={true}
                  modules={[Pagination, Navigation]}
                >
                  <SwiperSlide>
                    <Member
                      imgSrc={김진성}
                      imgSrcGray={김진성_gray}
                      name="김진성"
                      title="대표"
                      englishName="Gregory Kim"
                      discription="열정과 목적을 가지고<br>제대로 놀 줄 아는<br>플랜이슈 용역장인 "
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={박서희}
                      imgSrcGray={박서희_gray}
                      name="박서희"
                      title="이사"
                      englishName="Park, Seo-Hee"
                      discription="비평적인 관점과 뛰어난<br>통찰력을 가진 뛰어난 전략가"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={이소연}
                      imgSrcGray={이소연_gray}
                      name="이소연"
                      title="이사"
                      englishName="Lee, So-Yeoun"
                      discription="따뜻한 감성을 가지고<br>활력적으로 플랜이슈를<br>이끄는 총괄자"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={김민정}
                      imgSrcGray={김민정_gray}
                      name="김민정"
                      title="실장"
                      englishName="Kim Min Jung"
                      discription="조경과 관광컨설팅<br>전문성을 모두 갖춘<br>자타공인 멀티플레이어"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={조성학}
                      imgSrcGray={조성학_gray}
                      name="조성학"
                      title="실장"
                      englishName="SungHak Joe"
                      discription="넓게 보고 깊게 파고들어<br>지역의 미래를 그려내는<br> 드림메이커"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={최윤석}
                      imgSrcGray={최윤석_gray}
                      name="최윤석"
                      title="팀장"
                      englishName="CHOI Yoonseok"
                      discription="상상력이 풍부하고 독창적인<br>자유분방 예술가"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={강동민}
                      imgSrcGray={강동민_gray}
                      name="강동민"
                      title="팀장"
                      englishName="Kang Dong Min"
                      discription="데이터로 가능성을 찾고 관광의 내일을 설계하는 날카로운 기획자"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={권다현}
                      imgSrcGray={권다현_gray}
                      name="권다현"
                      title="팀장"
                      englishName="Da Hyun Kwon"
                      discription="지역의 숨은 이야기를 경험으로 연결하는<br>관광 스토리텔러"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={김슬기}
                      imgSrcGray={김슬기_gray}
                      name="김슬기"
                      title="팀장"
                      englishName="Kim Seulgi"
                      discription="트랜디한 시각으로 지역의 매력을 발굴하고<br>브랜딩하는 관광크리에이터"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Member
                      imgSrc={김현지}
                      imgSrcGray={김현지_gray}
                      name="김현지"
                      title="팀장"
                      englishName="Kim Hyunji"
                      discription="흩어진 자원 속에서 이야기를 발견해<br>공간과 콘텐츠로 풀어내는 설계자"
                    />
                  </SwiperSlide>
                </Swiper>
              </section>
            </section>
          </article>
        )}
      </ReactVisibilitySensor>
    </section>
  )
}

export default KeyMembers
